(function () {
  document.addEventListener("DOMContentLoaded", function () {
    window.toggleAccordion = function(button) {
      const wrapper = button.closest('.js_accordion');
      if (!wrapper) return;

      if (wrapper.classList.contains('is-open')) {
        wrapper.classList.remove('is-open');
        button.setAttribute('aria-expanded', 'false');
      }
      else {
        wrapper.classList.add('is-open');
        button.setAttribute('aria-expanded', 'true');
      }
    };
  });
})();